import React, {forwardRef, memo, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import {getImagePathWithThemeSvg} from "../../utils";
import Global from "@/global";
import {ipcInvoke} from "@/common/ipc";

const WebViewItem = forwardRef((props: {item:any,onClose:any,onPageInfoUpdate:any,onProgressLoading:any,onUpdateSearchInfo:any,onMouseDown:any},ref)=>{
    useImperativeHandle(ref,()=>({
        canGoBack:canGoBack,
        handleGoBack:handleGoBack,
        canGoForward:canGoForward,
        handleGoForward:handleGoForward,
        handleReload:handleReload,
        handleStop:handleStop,
        getZoomFactor:getZoomFactor,
        setZoomFactor:setZoomFactor,
        findText:findText,
        stopFindInPage:stopFindInPage,
        onRemove:onRemove,
        onUpdatePageUrl:onUpdatePageUrl
    }))
    const [pageInfo, setPageInfo] = useState({
        ...props.item,
        title: '',
        favicon: '',
        isLoading: true,
        canGoBack: false,
        canGoForward: false,
    });

    const [progressInfo,setProgressInfo] = useState({isLoading:false,progress:0});
    const mapCacheFavorIconRef = useRef<any>({});
    const webviewRef = useRef(null);
    const mWebviewDomIsReady = useRef(false);
    const mProgress = useRef(0);
    const mIsLoading = useRef(false);
    const mTimeoutIdRef = useRef<any>(0);
    const mEndTimeRef = useRef<any>(0);
    const [url,setUrl] = useState(props.item?.url)

    useEffect(() => {
        if (props.onPageInfoUpdate) {
            props.onPageInfoUpdate(pageInfo);
        }
    }, [pageInfo]);


    // 处理来自预加载脚本的消息
    const handleIpcMessage = useCallback((event) => {
        const { channel } = event;
        const data = event.args[0];

        switch (channel) {
            case 'page-info':
                const newPageInfo = {...pageInfo,title:data.title,url:data.url}
                setPageInfo(newPageInfo);
                break;
            case 'favicon-info':
                setPageInfo(prev => ({
                    ...prev,
                    favicon: data.favicon
                }));
                break;

            default:
                break;
        }
    }, [props.onPageInfoUpdate]);

    useEffect(() => {
        // const divContainer = document.getElementById('div-webview-container-'+props.item.id);
        // const rect = divContainer.getBoundingClientRect();
        // ipcInvoke('create-browser-view',{webInfo:props.item,bounds:rect})

        // 测试基础事件
        // webview.addEventListener('load-commit', (e) => {
        //     console.log('✅ load-commit event:', e.url);
        // });

        const webview:any = webviewRef.current;
        if (webview) {
            webview.addEventListener('page-title-updated', handlePageTitleUpdated);
            webview.addEventListener('page-favicon-updated', handlePageFaviconUpdated);
            webview.addEventListener('dom-ready', handleDomReady);
            webview.addEventListener('did-start-loading', handleLoadStart);
            webview.addEventListener('did-finish-load', handleLoadFinish);
            webview.addEventListener('did-stop-loading', handleStopLoading);
            webview.addEventListener('did-navigate', handleNavigate);
            // webview.addEventListener('did-navigate-in-page', handleNavigate);
            webview.addEventListener('found-in-page', handleFontInPage);

            webview.addEventListener('ipc-message', handleIpcMessage);
            // webview.addEventListener('new-window',handleNewWindow);
            webview.addEventListener('will-navigate',handleWillNavigate);
            webview.addEventListener('did-start-navigation',handleWillNavigate);
            // webview.addEventListener('render-process-gone',handleProgress);
        }

        return () => {
            if (webview) {
                webview.removeEventListener('page-title-updated', handlePageTitleUpdated);
                webview.removeEventListener('page-favicon-updated', handlePageFaviconUpdated);
                webview.removeEventListener('dom-ready', handleDomReady);
                webview.removeEventListener('did-start-loading', handleLoadStart);
                webview.removeEventListener('did-finish-load', handleLoadFinish);
                webview.removeEventListener('did-stop-loading', handleStopLoading);
                webview.removeEventListener('did-navigate', handleNavigate);
                // webview.removeEventListener('did-navigate-in-page', handleNavigate);
                webview.removeEventListener('found-in-page', handleFontInPage);
                webview.removeEventListener('console-message',handleConsoleMessage);
                webview.removeEventListener('ipc-message', handleIpcMessage);
                // webview.removeEventListener('new-window',handleNewWindow);
                webview.removeEventListener('will-navigate',handleWillNavigate);
                webview.removeEventListener('did-start-navigation',handleWillNavigate);
                // webview.removeEventListener('render-process-gone',handleProgress);
            }
        };
    },[]);


    useEffect(()=>{
        const webview:any = webviewRef.current;
        if (webview) {
            webview.addEventListener('console-message', handleConsoleMessage);
        }

        return ()=>{
            if (webview) {
                webview.removeEventListener('console-message',handleConsoleMessage);
            }
        }
    })

    const handleWebviewMessage = (event)=>{

    }


    /*******************这里是事件dom****************************/
    const handlePageTitleUpdated = (event) => {
        let favicon:any = null;
        if (event.current){
            favicon = mapCacheFavorIconRef[event.current?.src]
        }
        setPageInfo(prev => ({ ...prev, title: event.title}));
    };

    const handlePageFaviconUpdated = (event) => {
        if (event.favicons && event.favicons.length > 0) {
            mapCacheFavorIconRef.current[event.currentTarget.src] = event.favicons[0];
            setPageInfo(prev => ({ ...prev, favicon: event.favicons[0] }));
        }
    };

    const handleWillNavigate = (event)=>{
        const currentUrl = webviewRef.current?.src; // 获取当前完整 URL
        const newUrl = event.url;

        // 如果只是 hash 改变（协议+主机+路径相同），放行
        try {
            const current = new URL(currentUrl);
            const next = new URL(newUrl);

            const sameOriginAndPath =
                current.origin === next.origin &&
                current.pathname === next.pathname;

            if (sameOriginAndPath) {
                event.preventDefault();
                event.stopPropagation();
                return; // 允许 hash 跳转
            }
        } catch (err) {
            // URL 解析失败，谨慎处理
        }
    }

    const handleLoadStart = (event) => {
        if (Date.now() - mEndTimeRef.current > 1000){
            setPageInfo(prev => ({ ...prev,url:event.target.src, isLoading: true }));
            mIsLoading.current = true;
            visualProgress(0);

            //loadfinish后又来start 是什么意思？？？？？？？？？？
            // console.log('start-----------------end************************************************************************')
        }
    };

    const handleLoadFinish = (event) => {
        mEndTimeRef.current = Date.now();
        mIsLoading.current = false;
        mProgress.current = 0;

        props.onProgressLoading(0);
        setProgressInfo({isLoading:false,progress:mProgress.current});

        // console.log('end************************************************************************')

        setPageInfo(prev => ({ ...prev,isLoading: false }));
    };

    const handleStopLoading = (event)=>{
        setPageInfo(prev => ({ ...prev, isLoading: false }));
    }

    //这是处理back,forward---
    const handleNavigate = (event) => {
        setPageInfo(prev => ({
            ...prev,
            url: event.url,
        }));
    };

    const handleFontInPage = (event)=>{
        // webviewRef.current?.stopFindInPage('keepSelection')
        const result = event.result;
        const activeMatchOrdinal = result.activeMatchOrdinal;
        const matchesCount = result.matches;
        props.onUpdateSearchInfo(activeMatchOrdinal,matchesCount);
    }

    const handleConsoleMessage = (event)=>{
        console.log(event.message);
        if (event.message == '-mousedown-clicked-'){
            //内部的点击事件...关闭弹窗
            props.onMouseDown();
        }
    }

    const handleDomReady = () => {
        mWebviewDomIsReady.current = true;
        // webviewRef.current?.openDevTools()
        setPageInfo(prev => ({ ...prev, isLoading: false }));
        console.log('DOM 准备就绪');
        // 注入脚本确保链接正常工作
          webviewRef.current?.executeJavaScript(`
          // 确保所有链接都在当前窗口打开
          document.addEventListener('mousedown', function(e) {
            console.log('-mousedown-clicked-');
          },true);
        `);
    };

    /*******************这里是事件dom----end****************************/


    const visualProgress = (nDelayTime:any)=>{
        clearTimeout(mTimeoutIdRef.current);
        mTimeoutIdRef.current = setTimeout(()=>{
            if (mIsLoading.current){
                mProgress.current ++;
                props.onProgressLoading(mProgress.current);
                setProgressInfo({isLoading:true,progress:mProgress.current});
                visualProgress(nDelayTime+2);
            }else{
                setProgressInfo({isLoading:false,progress:0});
            }
        },nDelayTime)
    }

    const canGoBack = ()=>{
        if (mWebviewDomIsReady.current){
            try {
                try{
                    return webviewRef.current?.canGoBack();
                }catch (e){

                }
            }catch (e){

            }
        }
        return false;
    }
    const canGoForward = ()=>{
        if (mWebviewDomIsReady.current){
            return webviewRef.current?.canGoForward()
        }
        return false;
    }

    const handleGoBack = () => {
        if (webviewRef.current && webviewRef.current.canGoBack()) {
            webviewRef.current.goBack();
        }
    };

    const handleGoForward = () => {
        if (webviewRef.current && webviewRef.current.canGoForward()) {
            webviewRef.current.goForward();
        }
    };

    const handleReload = () => {
        webviewRef.current?.reload();
    };

    const handleStop = ()=>{
        webviewRef.current?.stop();
    }

    const getZoomFactor = ()=>{
        return webviewRef.current?.getZoomFactor();
    }

    const setZoomFactor = (zf)=>{
        webviewRef.current?.setZoomFactor(zf);
    }

    const findText = (szText,option)=>{
        return webviewRef.current?.findInPage(szText,option)
    }

    const stopFindInPage = ()=>{
        webviewRef.current?.stopFindInPage('clearSelection');
    }

    const onRemove = ()=>{
        webviewRef.current?.remove();
        webviewRef.current = null;
    }

    const onUpdatePageUrl = (szUrl)=>{
        setPageInfo(prev=>prev.url = szUrl);
    }

    return <div className={'flex-col'} id={'div-webview-container-'+props.item.id} style={{height:'100%',width:'100%',position:'relative'}}>
        {
            progressInfo.progress > 0 && progressInfo.progress <100 && progressInfo.isLoading &&
            <div style={{
                position: 'absolute',
                left: '0',
                top: '0',
                background: 'var(--primary-color)',
                height: '2px',
                width: `${progressInfo.progress}%`
            }}></div>
        }
        <webview
            ref={webviewRef}
            style={{border:'none',outline:'none',height:'100%',overflow:'auto'}}
            src={props.item.url}
            // preload={`file://${Global.g_appPath}webviewBrowsePreload.js`}
            title="Noteey Embedded Content"
            useragent={'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Noteey/1.38.0 Chrome/124.0.6367.243 Electron/30.5.1 Safari/537.36'}
            plugins={true}
            allowpopups="on"           // 允许弹出窗口
            disableguestresize="off"   // 允许调整大小
            autosize="on"              // 自动调整
            plugins="on"               // 启用插件（可选）
            />
    </div>
})

export default React.memo(WebViewItem,(prev,next)=>{
    return prev.item.url == next.item.url;
});